import { getRouteApi, useNavigate } from '@tanstack/react-router';
import * as React from 'react';

import { OperationalViewFournisseursScreen } from '@/routes/admin/operational-view/operational-view-fournisseurs-screen';

// =============================================================================
// operational-view-fournisseurs-route.tsx — Adaptateur routeur de la Page Fournisseurs (§2.5 v2.2 / C2).
// =============================================================================
// L'id de campagne est le path param d'URL (« /admin/campaigns/$campaignId/operational-view/fournisseurs »)
// — ressource d'URL, cohérent avec le contrat API (campaignId server-set, invariant n°1).

const routeApi = getRouteApi(
  '/admin/campaigns/$campaignId/operational-view/fournisseurs',
);

export function OperationalViewFournisseursRoute(): React.JSX.Element {
  const { campaignId } = routeApi.useParams();
  const navigate = useNavigate();

  const onViewProfils = React.useCallback((): void => {
    void navigate({
      to: '/admin/campaigns/$campaignId/operational-view/profils',
      params: { campaignId },
    });
  }, [navigate, campaignId]);

  return (
    <OperationalViewFournisseursScreen
      campaignId={campaignId}
      onViewProfils={onViewProfils}
    />
  );
}
